import {Injectable} from "@angular/core";
import {HttpClient} from "@angular/common/http";
import {Observable} from "rxjs/index";
import {connectApi} from "../connect-api";
import {CustomHttpParams} from "../connect-http-interceptor";
import {CirfDocument} from "../../cirf/cirf-document";
import {map} from "rxjs/internal/operators";
import {ReferralDocument} from '../../referral/referral-document';
import {CirfDriverLicense} from '../../cirf/cirf-driver-license';
import {MatterDocument} from "../../shared/matter-document";

@Injectable({
    providedIn: 'root'
})
export class FileUploadService {

    constructor(private  httpClient : HttpClient) {
    }

    uploadCirfFiles(formData: FormData, cirfGuid: string, sourceId: string, documentType: string) : Observable<CirfDocument>{
        let url = '';
        if(documentType == 'CLIENT'){
            url = connectApi.uploadClientFile.replace('{cirfGuid}', cirfGuid).replace('{clientId}', sourceId);
        } else if(documentType == 'MORTGAGE'){
            url = connectApi.uploadMortgageFile.replace('{cirfGuid}', cirfGuid).replace('{mortgageId}', sourceId);
        } else {
            url = connectApi.uploadFile.replace('{cirfGuid}', cirfGuid);
        }

        return this.httpClient.post<any>(url, formData, {
                params: new CustomHttpParams(true)
            }).pipe(map(result=> new CirfDocument(result['CirfDocument'])));
    }

    getCirfDocuments(cirfGuid: string) : Observable<CirfDocument[]> {
        let url = connectApi.getCirfDocuments.replace('{cirfGuid}', cirfGuid);
        return this.httpClient.get(url, { params: new CustomHttpParams(true) }).pipe(map(
            (result) => {
            let cirfDocuments : CirfDocument[] = [];
            let documents = result['CirfDocuments'];
            documents.forEach((doc)=>{
                cirfDocuments.push(new CirfDocument(doc));
            });
            return cirfDocuments;
        }));
    }

    deleteCirfDocument(cirfGuid: string, documentId: string) : Observable<CirfDocument> {
        let url = connectApi.deleteCirfDocument.replace('{cirfGuid}', cirfGuid).replace('{documentId}', documentId);
        return this.httpClient.delete(url, { params: new CustomHttpParams(true) })
            .pipe(map(
            (result) => {
            return new CirfDocument(result['CirfDocument']) ;
        }));
    }

    uploadReferralFiles(formData: FormData, referralId: number) : Observable<ReferralDocument>{
        const url = connectApi.uploadReferralFile.replace('{referralId}', referralId.toString());

        return this.httpClient.post<any>(url, formData, {
            params: new CustomHttpParams(true)
        }).pipe(map(result=> new ReferralDocument(result['ReferralDocument'])));
    }

    getReferralDocuments(referralId: number): Observable<ReferralDocument[]> {
        const url = connectApi.getReferralDocuments.replace('{referralId}', referralId.toString());
        return this.httpClient.get(url, {params: new CustomHttpParams(true)}).pipe(map(
            (result) => {
                return result['ReferralDocument'].map((doc) => {
                    return new ReferralDocument(doc);
                });
            }));
    }

    deleteReferralDocument(referralId: number, documentId: string) : Observable<ReferralDocument> {
        const url = connectApi.deleteReferralDocument
            .replace('{referralId}', referralId.toString())
            .replace('{documentId}', documentId);
        return this.httpClient.delete(url, { params: new CustomHttpParams(true) })
            .pipe(map(
                (result) => {
                    return new ReferralDocument(result['ReferralDocument']) ;
                }));
    }

    uploadMatterInfoFiles(formData: FormData, matterId: string) : Observable<MatterDocument>{
        const url = connectApi.uploadMatterInfoFile.replace('{matterId}', matterId);

        return this.httpClient.post<any>(url, formData, {
            params: new CustomHttpParams(true)
        }).pipe(map(result=> new MatterDocument(result['UnityConnectDocument'])));
    }
}
